
import {shareReplay, distinctUntilChanged } from 'rxjs/operators';
import { Subject ,  Observable } from 'rxjs';
import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { LocalizedSurvey, AdminSurvey } from '../models/questions';

@Injectable()
export class SurveyService {

  selfAssesmentSurveyName$: Observable<string>;

  private readonly selfAssesmentSurveyNameSubject = new Subject<string>();
  private readonly apiController = 'api/survey';

  constructor(private readonly httpService: HttpClient) { 
    this.selfAssesmentSurveyName$ = this.selfAssesmentSurveyNameSubject.asObservable();
  }

  getAll(): Observable<Array<LocalizedSurvey>> {
    return this.httpService.get(`${this.apiController}`) as Observable<Array<LocalizedSurvey>>;
  }

  getOne(surveyId: number): Observable<AdminSurvey> {
   return this.httpService.get(`${this.apiController}/${surveyId}`);
  }

  add(survey: AdminSurvey) {
    return this.httpService.post(this.apiController, survey).pipe(
        shareReplay())
        .pipe(distinctUntilChanged());
  }

  update(survey: AdminSurvey): Observable<any> {
    return this.httpService.put(`${this.apiController}/${survey.id}`, survey)
        .pipe(distinctUntilChanged());
  }

  selfAssessmentSurveyOpen(surveyName: string) {
    this.selfAssesmentSurveyNameSubject.next(surveyName);
  }
}
